import { jsonGet, jsonPost } from 'api'

const NPS_ADMIN_CREDENTIALS_KEY = 'npsAdminCredentials'

export const setAdminCredentials = (username, password) =>
    sessionStorage.setItem(NPS_ADMIN_CREDENTIALS_KEY, btoa(`${username}:${password}`))

export const clearAdminCredentials = () => sessionStorage.removeItem(NPS_ADMIN_CREDENTIALS_KEY)

export const hasAdminCredentials = () => Boolean(sessionStorage.getItem(NPS_ADMIN_CREDENTIALS_KEY))

const adminAuthHeader = () => ({
    Authorization: `Basic ${sessionStorage.getItem(NPS_ADMIN_CREDENTIALS_KEY)}`,
})

export const getAllUsersSurveysByCountry = (country, language, userId) =>
    jsonGet(`${SF_PROXY_URL}/nps/${country}/${language}/${userId}`).catch(error => {
        throw new Error(error.message)
    })

export const sendUsersSurveyByUseId = (country, language, userId, rating, ratingText) =>
    jsonPost(`${SF_PROXY_URL}/nps/${country}/${language}/${userId}`, { rating, ratingText }).catch(error => {
        throw new Error(error.message)
    })

export const getAllSurveysByCountryAdmin = country =>
    jsonGet(`${SF_PROXY_URL}/admin/nps/${country}`, null, adminAuthHeader()).catch(error => {
        throw new Error(error.message)
    })

export const getSurveyResultsById = (country, surveyId) =>
    jsonGet(`${SF_PROXY_URL}/admin/nps/${country}/${surveyId}`, null, adminAuthHeader()).catch(error => {
        throw new Error(error.message)
    })

export const getSurveyTextAnswersById = (country, surveyId, page = 1, pageSize = 6, rating = -1) =>
    jsonGet(
        `${SF_PROXY_URL}/admin/nps/${country}/${surveyId}/answers?page=${page}&pageSize=${pageSize}&rating=${rating}`,
        null,
        adminAuthHeader()
    ).catch(error => {
        throw new Error(error.message)
    })

export const addNewSurveyByCountry = (country, newSurvey) =>
    jsonPost(`${SF_PROXY_URL}/admin/nps/${country}`, newSurvey, adminAuthHeader()).catch(error => {
        throw new Error(error.message)
    })

export const cancelSurveyById = (country, surveyId) =>
    jsonPost(`${SF_PROXY_URL}/admin/nps/${country}/${surveyId}/deactivate`, null, adminAuthHeader()).catch(error => {
        throw new Error(error.message)
    })

export const getSurveyCSV = async (country, id) => {
    try {
        const response = await fetch(`${SF_PROXY_URL}/admin/nps/${country}/${id}/answers_csv`, {
            method: 'GET',
            headers: adminAuthHeader(),
        })
        return await response.blob()
    } catch (error) {
        throw new Error(error.message)
    }
}
